class CustomScrollbar {
  constructor(element) {
    this.content = element;
    this.isScrolling = false;
    this.lastY = 0;
    this.accordion = element.closest("details");

    this.init();
    this.addEventListeners();
  }

  init() {
    // Create scrollbar thumb
    this.thumb = document.createElement("div");
    this.thumb.className = "custom-scrollbar-thumb";
    this.content.parentNode.appendChild(this.thumb);

    // Initial update of thumb size and position
    this.updateThumb();

    // Add click event to accordion summary
    if (this.accordion) {
      const summary = this.accordion.querySelector("summary");
      if (summary) {
        summary.addEventListener("click", (e) => {
          if (this.accordion.hasAttribute("open")) {
            // If accordion is open and being clicked to close
            this.thumb.style.display = "none";
          } else {
            // If accordion is closed and being clicked to open
            // Add 0.3s delay before showing the scrollbar
            setTimeout(() => {
              if (this.accordion.hasAttribute("open")) {
                this.thumb.style.display = "block";
                this.updateThumb(); // Update position after showing
              }
            }, 300); // 300ms = 0.3s delay
          }
        });
      }
    }
  }

  updateThumb() {
    const contentHeight = this.content.scrollHeight;
    const visibleHeight = this.content.clientHeight;

    // Calculate thumb height based on content proportion
    const scrollRatio = visibleHeight / contentHeight;
    const thumbHeight = Math.max(Math.round(scrollRatio * visibleHeight), 40); // minimum 40px height
    this.thumb.style.height = `${thumbHeight}px`;

    // Update thumb position
    const scrollPercent =
      this.content.scrollTop / (contentHeight - visibleHeight);
    const maxTop = visibleHeight - thumbHeight;
    const thumbTop = scrollPercent * maxTop;
    this.thumb.style.top = `${this.content.offsetTop + thumbTop}px`;

    // Show/hide thumb based on content scrollability
    if (contentHeight <= visibleHeight) {
      this.thumb.style.display = "none";
    }
  }

  addEventListeners() {
    // Update thumb position on scroll
    this.content.addEventListener("scroll", () => {
      if (!this.isScrolling) {
        window.requestAnimationFrame(() => {
          this.updateThumb();
          this.isScrolling = false;
        });
      }
      this.isScrolling = true;
    });

    // Handle thumb drag
    this.thumb.addEventListener("mousedown", this.onThumbMouseDown.bind(this));
    this.thumb.addEventListener(
      "touchstart",
      this.onThumbTouchStart.bind(this)
    );

    // Handle window resize
    window.addEventListener("resize", () => {
      this.updateThumb();
    });
  }

  onThumbMouseDown(e) {
    e.preventDefault();
    this.startDrag(e.clientY);

    document.addEventListener("mousemove", this.onMouseMove.bind(this));
    document.addEventListener("mouseup", this.onDragEnd.bind(this));
  }

  onThumbTouchStart(e) {
    e.preventDefault();
    this.startDrag(e.touches[0].clientY);

    document.addEventListener("touchmove", this.onTouchMove.bind(this));
    document.addEventListener("touchend", this.onDragEnd.bind(this));
  }

  startDrag(clientY) {
    this.isDragging = true;
    this.lastY = clientY;
    this.thumb.style.width = "6px";
  }

  onMouseMove(e) {
    if (this.isDragging) {
      this.updateContentScroll(e.clientY);
    }
  }

  onTouchMove(e) {
    if (this.isDragging) {
      this.updateContentScroll(e.touches[0].clientY);
    }
  }

  updateContentScroll(clientY) {
    const delta = clientY - this.lastY;
    const contentHeight = this.content.scrollHeight;
    const visibleHeight = this.content.clientHeight;

    const scrollDelta = (delta * contentHeight) / visibleHeight;
    this.content.scrollTop += scrollDelta;

    this.lastY = clientY;
    this.updateThumb();
  }

  onDragEnd() {
    this.isDragging = false;
    this.thumb.style.width = "4px";

    document.removeEventListener("mousemove", this.onMouseMove.bind(this));
    document.removeEventListener("mouseup", this.onDragEnd.bind(this));
    document.removeEventListener("touchmove", this.onTouchMove.bind(this));
    document.removeEventListener("touchend", this.onDragEnd.bind(this));
  }
}

// Initialize custom scrollbars for all accordion content elements
document.addEventListener("DOMContentLoaded", () => {
  const accordionContents = document.querySelectorAll(
    ".product__accordion .accordion__content"
  );
  accordionContents.forEach((content) => {
    new CustomScrollbar(content);
  });
});
